import React from 'react';

/**
 * Stats Bar Component - Display constellation connection statistics
 * 
 * Shows total connections and breakdown by type (light/strong/bonded)
 * 
 * @param {Object} props
 * @param {Object} props.data - Constellation response data
 */
export const ConstellationStatsBar = ({ data }) => {
  // Calculate stats from either API stats field or by filtering nodes
  const total = data.stats?.total_connections ?? data.nodes.length;
  const light = data.stats?.light_count ?? data.nodes.filter(n => n.connection_type === 'light').length;
  const strong = data.stats?.strong_count ?? data.nodes.filter(n => n.connection_type === 'strong').length;
  const bonded = data.stats?.bonded_count ?? data.nodes.filter(n => n.connection_type === 'bonded').length;

  return (
    <div className="px-4 pt-3 pb-2 border-b border-gray-800 bg-black/80">
      <div className="text-xs text-gray-400 mb-1">
        Your Constellation
      </div>
      <div className="flex items-center justify-between">
        <div className="text-sm font-medium text-white">
          {total} connection{total === 1 ? '' : 's'}
        </div>
        <div className="flex gap-3 text-[11px] text-gray-400">
          <span>🌑 {light} light</span>
          <span>⭐ {strong} strong</span>
          <span>💜 {bonded} bonded</span>
        </div>
      </div>
    </div>
  );
};
